// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* yoked — minimalist / sharp theme, warm neutral palette, Space Mono.
   Light is the default; [data-theme="dark"] overrides. Toggle persists in localStorage. */

:root {
  color-scheme: light;
  --bg: #f5f2ed;
  --text: #2a2a2a;
  --heading: #1a1a1a;
  --muted: #8a857b;
  --faint: #9a948a;
  --line: #c8c2b8;
  --line-soft: #d6d0c6;
  --panel: #fcfbf8;
  --panel-2: #efeae1;
  --track: #e4dfd5;
  --accent: #4a8c64;
  --accent-dim: rgba(74, 140, 100, 0.1);
  --on-accent: #f6f4ef;
  --danger: #b44040;
  --protein: #3f7cac;
  --carbs: #b07d2e;
  --fat: #9d5a7a;
  --warn: #bf8a3a;
  /* the add button: dark tile + light-lavender edge & glyph, in both themes */
  --lav: #ded7f2;
  --fab-bg: #201c18;
  --r: 3px;
}

[data-theme='dark'] {
  color-scheme: dark;
  --bg: #191714;
  --text: #cfcabf;
  --heading: #f2ede3;
  --muted: #857f72;
  --faint: #6f6a61;
  --line: #35322b;
  --line-soft: #2b2823;
  --panel: #201d19;
  --panel-2: #262320;
  --track: #2b2823;
  --accent: #5aa778;
  --accent-dim: rgba(90, 167, 120, 0.13);
  --on-accent: #14130f;
  --danger: #c65a5a;
  --protein: #5b9bd0;
  --carbs: #ca9750;
  --fat: #c07da0;
  --warn: #d3a259;
}

* {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

html,
body,
#app {
  height: 100%;
  margin: 0;
}

body {
  background: var(--bg);
  color: var(--text);
  font-family: 'Space Mono', ui-monospace, 'Courier New', monospace;
  font-size: 15px;
  -webkit-font-smoothing: antialiased;
  overscroll-behavior-y: none;
  transition: background-color 0.3s ease, color 0.3s ease;
}

button {
  font-family: inherit;
  cursor: pointer;
  border: none;
  background: none;
  color: inherit;
}
input {
  font-family: inherit;
}

/* labels: uppercase + tracked — the editorial signature */
.upper {
  text-transform: uppercase;
  letter-spacing: 2px;
}

/* ---- shell ---- */
.app {
  height: 100%;
  max-width: 480px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  position: relative;
  background: var(--bg);
  border-left: 1px solid var(--line-soft);
  border-right: 1px solid var(--line-soft);
  overflow: hidden;
}
.screen {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.page {
  padding: 16px 16px 28px;
  min-height: 100%;
}
/* Today: week strip sits right up near the top of the screen */
.today-page {
  padding-top: 8px;
}

/* ---- settings: appearance row + theme toggle pill ---- */
.set-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.theme-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: 1px solid var(--line);
  border-radius: var(--r);
  background: var(--panel-2);
  color: var(--text);
  transition: border-color 0.2s, transform 0.1s;
}
.theme-toggle:active {
  transform: scale(0.96);
}
.theme-toggle svg {
  display: block;
  width: 15px;
  height: 15px;
  color: var(--muted);
}
.theme-toggle-txt {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}
.field-hint {
  font-size: 10px;
  color: var(--muted);
  line-height: 1.6;
  margin-top: 8px;
}

/* ---- splash ---- */
.splash {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 6px;
  color: var(--muted);
  background: var(--bg);
  animation: pulse 1.2s ease-in-out infinite;
}
@keyframes pulse {
  50% {
    opacity: 0.4;
  }
}

/* ---- auth ---- */
.auth {
  min-height: 100%;
  max-width: 480px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 24px 22px calc(24px + env(safe-area-inset-bottom));
  background: var(--bg);
  border-left: 1px solid var(--line-soft);
  border-right: 1px solid var(--line-soft);
}
.auth-card {
  border: 1px solid var(--line);
  background: var(--panel);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.auth-row {
  display: flex;
  gap: 10px;
  align-items: stretch;
}
.auth-row .input {
  flex: 1;
}
.auth-go {
  flex-shrink: 0;
  width: 52px;
  border-radius: var(--r);
  background: var(--accent);
  color: var(--on-accent);
  font-size: 22px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.1s, opacity 0.15s;
}
.auth-go:active {
  transform: scale(0.92);
}
.auth-go:disabled {
  opacity: 0.4;
}
.auth-err {
  color: var(--danger);
  font-size: 12px;
  text-align: center;
}
.auth-confirm {
  border-top: 1px solid var(--line);
  padding-top: 14px;
}
.auth-confirm-q {
  color: var(--muted);
  font-size: 12px;
  text-align: center;
  margin-bottom: 12px;
  line-height: 1.6;
}
.auth-confirm-q b {
  color: var(--heading);
}
.welcome-title {
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: var(--heading);
}
.welcome-sub {
  font-size: 12px;
  color: var(--muted);
  line-height: 1.6;
  margin-top: -4px;
}

/* ---- bottom tab bar ---- */
.tabbar {
  flex-shrink: 0;
  display: flex;
  background: var(--bg);
  border-top: 1px solid var(--line);
  padding-bottom: env(safe-area-inset-bottom);
}
.tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 10px 0 9px;
  color: var(--muted);
  text-decoration: none;
  font-size: 8px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  transition: color 0.15s;
}
.tab-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  opacity: 0.75;
  transition: opacity 0.15s, transform 0.1s;
}
.tab-icon svg {
  width: 20px;
  height: 20px;
  display: block;
}
.tab-active {
  color: var(--accent);
}
.tab-active .tab-icon {
  opacity: 1;
}
.tab:active .tab-icon {
  transform: scale(0.88);
}

/* ---- week strip ---- */
.week {
  display: flex;
  gap: 5px;
  margin-bottom: 12px;
}
.wk {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 5px 0 4px;
  border: 1px solid var(--line-soft);
  border-radius: var(--r);
  background: transparent;
  transition: background 0.15s, border-color 0.15s, transform 0.1s;
}
.wk:active {
  transform: scale(0.94);
}
.wk:disabled {
  opacity: 0.35;
  pointer-events: none;
}
.wk-dow {
  font-size: 9px;
  font-weight: 700;
  color: var(--muted);
  letter-spacing: 1px;
}
.wk-dom {
  font-size: 14px;
  font-weight: 700;
  color: var(--text);
}
.wk-today .wk-dom {
  color: var(--accent);
}
.wk-on {
  background: var(--accent-dim);
  border-color: var(--accent);
}
.wk-on .wk-dow,
.wk-on .wk-dom {
  color: var(--accent);
}

/* ---- today head ---- */
.today-head {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 14px;
}
.today-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  min-width: 130px;
  text-align: center;
  color: var(--heading);
}
.icon-btn {
  width: 40px;
  height: 40px;
  border-radius: var(--r);
  font-size: 22px;
  color: var(--muted);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, transform 0.1s;
}
.icon-btn.sm {
  width: 30px;
  height: 30px;
  font-size: 20px;
}
.icon-btn:active {
  background: var(--panel-2);
  transform: scale(0.92);
}
.icon-btn:disabled {
  opacity: 0.25;
  pointer-events: none;
}
.linkish {
  color: var(--accent);
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  padding: 2px 0;
}

/* ---- daily summary ---- */
.summary {
  border: 1px solid var(--line);
  background: var(--panel);
  border-radius: var(--r);
  padding: 16px;
  margin-bottom: 16px;
}
.cal-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}
.cal-now {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.cal-now-num {
  font-size: 30px;
  font-weight: 700;
  letter-spacing: -1px;
  color: var(--heading);
}
.cal-now-unit {
  color: var(--muted);
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.cal-status {
  color: var(--muted);
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
}
/* dual-marker track: fill = consumed; ticks = target + maintenance */
.cal-track {
  position: relative;
  height: 8px;
  border-radius: 2px;
  background: var(--track);
  overflow: hidden;
  margin-top: 12px;
}
.cal-fill {
  height: 100%;
  transition: width 0.5s cubic-bezier(0.25, 1, 0.5, 1), background 0.3s;
}
.cal-mark {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  transform: translateX(-1px);
}
.cal-mark-target {
  background: var(--accent);
}
.cal-mark-maint {
  background: var(--heading);
  opacity: 0.55;
}
.cal-lines {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.cal-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cal-line-k {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 9px;
  font-weight: 700;
}
.cal-line-v {
  color: var(--text);
  font-size: 12px;
  font-weight: 700;
}
.cal-tick {
  width: 8px;
  height: 8px;
  border-radius: 2px;
  flex-shrink: 0;
}
.cal-tick-target {
  background: var(--accent);
}
.cal-tick-maint {
  background: var(--heading);
  opacity: 0.55;
}

/* ---- macro bars ---- */
.macros {
  display: flex;
  flex-direction: column;
  gap: 13px;
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid var(--line-soft);
}
.macro {
  width: 100%;
}
.macro-top {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 6px;
}
.macro-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}
.macro-val {
  font-size: 12px;
  font-weight: 700;
  color: var(--text);
}
.macro-unit {
  color: var(--muted);
  font-weight: 400;
}
.macro-goal {
  color: var(--muted);
  font-size: 11px;
  font-weight: 400;
}
.macro-track {
  height: 5px;
  border-radius: 2px;
  background: var(--track);
  overflow: hidden;
}
.macro-fill {
  height: 100%;
  transition: width 0.5s cubic-bezier(0.25, 1, 0.5, 1);
}
/* fat has no goal by default — show a faint baseline instead of an empty bar */
.macro-track-empty {
  height: 100%;
  background: repeating-linear-gradient(90deg, var(--line-soft) 0 6px, transparent 6px 12px);
  opacity: 0.6;
}

/* ---- timeline ---- */
.timeline {
  display: flex;
  flex-direction: column;
}
.tl-row {
  display: flex;
  gap: 10px;
}
.tl-time {
  width: 58px;
  flex-shrink: 0;
  text-align: right;
  font-size: 10px;
  color: var(--muted);
  padding-top: 15px;
  letter-spacing: 0.5px;
}
.tl-rail {
  width: 12px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  position: relative;
}
.tl-rail::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background: var(--line);
}
.tl-row:first-child .tl-rail::before {
  top: 17px;
}
.tl-row:last-child .tl-rail::before {
  bottom: calc(100% - 25px);
}
.tl-dot {
  position: absolute;
  top: 17px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--accent);
  box-shadow: 0 0 0 3px var(--bg);
}
.tl-card {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 11px;
  text-align: left;
  border: 1px solid var(--line-soft);
  background: var(--panel);
  border-radius: var(--r);
  padding: 10px 12px;
  margin-bottom: 9px;
  transition: transform 0.1s, border-color 0.15s;
}
.tl-card:active {
  transform: scale(0.99);
  border-color: var(--faint);
}
.tl-thumb {
  width: 44px;
  height: 44px;
  border-radius: var(--r);
  object-fit: cover;
  flex-shrink: 0;
}
.tl-body {
  flex: 1;
  min-width: 0;
}
.tl-name {
  font-size: 13px;
  font-weight: 700;
  color: var(--heading);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tl-cal {
  font-size: 15px;
  font-weight: 700;
  color: var(--heading);
}

.entry-macros {
  display: flex;
  gap: 10px;
  margin-top: 3px;
  font-size: 10px;
  color: var(--muted);
}
.entry-qty {
  color: var(--muted);
}

.add-hint {
  text-align: center;
  margin: 10px 0 4px;
}

/* ---- generic entry rows (Foods) ---- */
.list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.entry {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  text-align: left;
  border: 1px solid var(--line-soft);
  background: var(--panel);
  border-radius: var(--r);
  padding: 12px 13px;
  transition: transform 0.1s, border-color 0.15s;
}
.entry:active {
  transform: scale(0.99);
  border-color: var(--faint);
}
.entry-static:active {
  transform: none;
  border-color: var(--line-soft);
}
.entry-main {
  flex: 1;
  min-width: 0;
}
.entry-name {
  font-size: 13px;
  font-weight: 700;
  color: var(--heading);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.entry-cal {
  font-size: 15px;
  font-weight: 700;
  color: var(--heading);
}
.entry-del {
  color: var(--muted);
  font-size: 12px;
  padding: 6px;
  margin: -6px -4px -6px 0;
  border-radius: var(--r);
  transition: color 0.15s, background 0.15s;
}
.entry-del:active {
  color: var(--danger);
  background: var(--panel-2);
}

.empty {
  text-align: center;
  color: var(--muted);
  padding: 40px 20px;
  line-height: 1.7;
  font-size: 12px;
}

/* ---- floating action button ---- */
.fab {
  position: absolute;
  right: 18px;
  bottom: calc(74px + env(safe-area-inset-bottom));
  width: 52px;
  height: 52px;
  border-radius: 6px;
  background: var(--fab-bg);
  border: 1.5px solid var(--lav);
  color: var(--lav);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.22);
  transition: transform 0.12s, border-color 0.15s;
  z-index: 20;
}
.fab svg {
  width: 26px;
  height: 26px;
}
.fab:active {
  transform: scale(0.9);
}

/* ---- bottom sheet ---- */
.sheet-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: flex-end;
  z-index: 40;
  animation: fade 0.2s ease;
}
.sheet {
  width: 100%;
  background: var(--bg);
  border-top: 1px solid var(--line);
  border-radius: var(--r) var(--r) 0 0;
  padding: 10px 16px calc(20px + env(safe-area-inset-bottom));
  max-height: 92%;
  overflow-y: auto;
  animation: slideup 0.28s cubic-bezier(0.25, 1, 0.5, 1);
}
@keyframes slideup {
  from {
    transform: translateY(100%);
  }
}
@keyframes fade {
  from {
    opacity: 0;
  }
}
.sheet-handle {
  width: 36px;
  height: 3px;
  border-radius: 2px;
  background: var(--line);
  margin: 4px auto 14px;
}
.sheet-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: var(--heading);
  margin-bottom: 12px;
}
.sheet-sep {
  text-align: center;
  color: var(--muted);
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin: 14px 0 10px;
}
.sheet-actions {
  display: flex;
  gap: 10px;
  margin-top: 18px;
}
.sheet-note {
  font-size: 11px;
  color: var(--muted);
  margin-top: 12px;
  line-height: 1.6;
}
.sheet-photo {
  position: relative;
  margin: 8px 0 4px;
  border: 1px solid var(--line-soft);
  border-radius: var(--r);
  overflow: hidden;
}
.sheet-photo img {
  width: 100%;
  max-height: 240px;
  object-fit: cover;
  display: block;
}
.analyzing {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #fff;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.25);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.results {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
  max-height: 220px;
  overflow-y: auto;
}
.result {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--line-soft);
  background: var(--panel);
  border-radius: var(--r);
  padding: 11px 13px;
  text-align: left;
  transition: border-color 0.15s;
}
.result:active {
  border-color: var(--accent);
}
.result-name {
  font-size: 13px;
  font-weight: 700;
  color: var(--heading);
}
.result-cal {
  font-size: 11px;
  color: var(--accent);
}

/* ---- forms ---- */
.input {
  width: 100%;
  background: var(--panel-2);
  border: 1px solid var(--line);
  border-radius: var(--r);
  padding: 12px 13px;
  color: var(--text);
  font-size: 15px;
  outline: none;
  transition: border-color 0.15s;
}
.input::placeholder {
  color: var(--muted);
}
.input:focus {
  border-color: var(--accent);
}
.input.mt {
  margin-top: 12px;
}
.row {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}
.field {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.field-wide {
  margin-top: 12px;
}
.field-label {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: var(--muted);
}

/* ---- buttons ---- */
.btn {
  flex: 1;
  border-radius: var(--r);
  padding: 13px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  transition: transform 0.1s, opacity 0.15s;
}
.btn:active {
  transform: scale(0.98);
}
.btn:disabled {
  opacity: 0.5;
  pointer-events: none;
}
.btn-primary {
  background: var(--accent);
  color: var(--on-accent);
}
.btn-danger {
  background: transparent;
  color: var(--danger);
  border: 1px solid var(--line);
  flex: 0 0 auto;
  padding-left: 20px;
  padding-right: 20px;
}
.btn-ghost {
  width: 100%;
  background: transparent;
  border: 1px solid var(--line);
  color: var(--muted);
}
.btn-block {
  width: 100%;
  margin-top: 18px;
}

/* ---- page headers ---- */
.page-head {
  margin-bottom: 20px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--line);
}
.page-head h1 {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 3px;
  color: var(--heading);
}
.page-sub {
  color: var(--muted);
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  display: block;
  margin-top: 6px;
}

/* ---- cards / stats ---- */
.card {
  border: 1px solid var(--line);
  background: var(--panel);
  border-radius: var(--r);
  padding: 16px;
}
.stat-row {
  display: flex;
  gap: 10px;
  margin-bottom: 18px;
}
.stat {
  flex: 1;
  border: 1px solid var(--line-soft);
  background: var(--panel);
  border-radius: var(--r);
  padding: 14px;
}
.stat-value {
  font-size: 22px;
  font-weight: 700;
  color: var(--heading);
  letter-spacing: -0.5px;
}
.stat-unit {
  font-size: 11px;
  color: var(--muted);
}
.stat-label {
  color: var(--muted);
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-top: 4px;
}

/* ---- history ---- */
.hist {
  display: flex;
  flex-direction: column;
  gap: 9px;
}
.hist-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.hist-date {
  width: 84px;
  flex-shrink: 0;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--muted);
}
.hist-bar-track {
  flex: 1;
  position: relative;
  height: 20px;
  background: var(--track);
  border-radius: var(--r);
  overflow: hidden;
}
.hist-bar {
  height: 100%;
  transition: width 0.5s cubic-bezier(0.25, 1, 0.5, 1);
}
.hist-goal {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background: var(--faint);
}
.hist-cal {
  width: 50px;
  flex-shrink: 0;
  text-align: right;
  font-size: 13px;
  font-weight: 700;
  color: var(--heading);
}

.ios-tip {
  margin-top: 12px;
  padding: 12px 14px;
  border: 1px solid var(--line-soft);
  border-radius: var(--r);
  background: var(--panel);
  color: var(--muted);
  font-size: 12px;
  line-height: 1.6;
  text-align: center;
}
.ios-tip b {
  color: var(--heading);
}

.footnote {
  text-align: center;
  color: var(--muted);
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  line-height: 1.8;
  margin-top: 22px;
}

/* ---- toast ---- */
.toast {
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: calc(84px + env(safe-area-inset-bottom));
  background: var(--danger);
  color: #fff;
  padding: 12px 15px;
  border-radius: var(--r);
  font-size: 12px;
  text-align: center;
  z-index: 50;
  animation: slideup 0.25s ease;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;0FAC0F;;AAE1F;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4EAA4E;EAC5E,cAAc;EACd,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;;;EAGE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iEAAiE;EACjE,eAAe;EACf,mCAAmC;EACnC,2BAA2B;EAC3B,uDAAuD;AACzD;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;;AAEA,0DAA0D;AAC1D;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,uCAAuC;EACvC,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA,+DAA+D;AAC/D;EACE,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;AAC5C;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2DAA2D;EAC3D,qBAAqB;EACrB,uCAAuC;EACvC,wCAAwC;AAC1C;AACA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,OAAO;AACT;AACA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,iCAAiC;EACjC,2CAA2C;AAC7C;AACA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;EACvB,uBAAuB;EACvB,gEAAgE;AAClE;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;;EAEE,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;AACA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,qEAAqE;AACvE;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oDAAoD;AACtD;AACA,+EAA+E;AAC/E;EACE,YAAY;EACZ,0FAA0F;EAC1F,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kCAAkC;EAClC,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,uBAAuB;EACvB,yCAAyC;AAC3C;AACA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,WAAW;EACX,gDAAgD;EAChD,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,+CAA+C;EAC/C,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,iCAAiC;EACjC,oCAAoC;EACpC,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,sDAAsD;AACxD;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,sBAAsB;EACtB,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,OAAO;EACP,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;AACtC;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,OAAO;EACP,kCAAkC;EAClC,wBAAwB;EACxB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oDAAoD;AACtD;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gDAAgD;EAChD,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,0CAA0C;AAC5C","sourcesContent":["/* yoked — minimalist / sharp theme, warm neutral palette, Space Mono.\n   Light is the default; [data-theme=\"dark\"] overrides. Toggle persists in localStorage. */\n\n:root {\n  color-scheme: light;\n  --bg: #f5f2ed;\n  --text: #2a2a2a;\n  --heading: #1a1a1a;\n  --muted: #8a857b;\n  --faint: #9a948a;\n  --line: #c8c2b8;\n  --line-soft: #d6d0c6;\n  --panel: #fcfbf8;\n  --panel-2: #efeae1;\n  --track: #e4dfd5;\n  --accent: #4a8c64;\n  --accent-dim: rgba(74, 140, 100, 0.1);\n  --on-accent: #f6f4ef;\n  --danger: #b44040;\n  --protein: #3f7cac;\n  --carbs: #b07d2e;\n  --fat: #9d5a7a;\n  --warn: #bf8a3a;\n  /* the add button: dark tile + light-lavender edge & glyph, in both themes */\n  --lav: #ded7f2;\n  --fab-bg: #201c18;\n  --r: 3px;\n}\n\n[data-theme='dark'] {\n  color-scheme: dark;\n  --bg: #191714;\n  --text: #cfcabf;\n  --heading: #f2ede3;\n  --muted: #857f72;\n  --faint: #6f6a61;\n  --line: #35322b;\n  --line-soft: #2b2823;\n  --panel: #201d19;\n  --panel-2: #262320;\n  --track: #2b2823;\n  --accent: #5aa778;\n  --accent-dim: rgba(90, 167, 120, 0.13);\n  --on-accent: #14130f;\n  --danger: #c65a5a;\n  --protein: #5b9bd0;\n  --carbs: #ca9750;\n  --fat: #c07da0;\n  --warn: #d3a259;\n}\n\n* {\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: transparent;\n}\n\nhtml,\nbody,\n#app {\n  height: 100%;\n  margin: 0;\n}\n\nbody {\n  background: var(--bg);\n  color: var(--text);\n  font-family: 'Space Mono', ui-monospace, 'Courier New', monospace;\n  font-size: 15px;\n  -webkit-font-smoothing: antialiased;\n  overscroll-behavior-y: none;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\nbutton {\n  font-family: inherit;\n  cursor: pointer;\n  border: none;\n  background: none;\n  color: inherit;\n}\ninput {\n  font-family: inherit;\n}\n\n/* labels: uppercase + tracked — the editorial signature */\n.upper {\n  text-transform: uppercase;\n  letter-spacing: 2px;\n}\n\n/* ---- shell ---- */\n.app {\n  height: 100%;\n  max-width: 480px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  background: var(--bg);\n  border-left: 1px solid var(--line-soft);\n  border-right: 1px solid var(--line-soft);\n  overflow: hidden;\n}\n.screen {\n  flex: 1;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.page {\n  padding: 16px 16px 28px;\n  min-height: 100%;\n}\n/* Today: week strip sits right up near the top of the screen */\n.today-page {\n  padding-top: 8px;\n}\n\n/* ---- settings: appearance row + theme toggle pill ---- */\n.set-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n.theme-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border: 1px solid var(--line);\n  border-radius: var(--r);\n  background: var(--panel-2);\n  color: var(--text);\n  transition: border-color 0.2s, transform 0.1s;\n}\n.theme-toggle:active {\n  transform: scale(0.96);\n}\n.theme-toggle svg {\n  display: block;\n  width: 15px;\n  height: 15px;\n  color: var(--muted);\n}\n.theme-toggle-txt {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n}\n.field-hint {\n  font-size: 10px;\n  color: var(--muted);\n  line-height: 1.6;\n  margin-top: 8px;\n}\n\n/* ---- splash ---- */\n.splash {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 6px;\n  color: var(--muted);\n  background: var(--bg);\n  animation: pulse 1.2s ease-in-out infinite;\n}\n@keyframes pulse {\n  50% {\n    opacity: 0.4;\n  }\n}\n\n/* ---- auth ---- */\n.auth {\n  min-height: 100%;\n  max-width: 480px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 24px 22px calc(24px + env(safe-area-inset-bottom));\n  background: var(--bg);\n  border-left: 1px solid var(--line-soft);\n  border-right: 1px solid var(--line-soft);\n}\n.auth-card {\n  border: 1px solid var(--line);\n  background: var(--panel);\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.auth-row {\n  display: flex;\n  gap: 10px;\n  align-items: stretch;\n}\n.auth-row .input {\n  flex: 1;\n}\n.auth-go {\n  flex-shrink: 0;\n  width: 52px;\n  border-radius: var(--r);\n  background: var(--accent);\n  color: var(--on-accent);\n  font-size: 22px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.1s, opacity 0.15s;\n}\n.auth-go:active {\n  transform: scale(0.92);\n}\n.auth-go:disabled {\n  opacity: 0.4;\n}\n.auth-err {\n  color: var(--danger);\n  font-size: 12px;\n  text-align: center;\n}\n.auth-confirm {\n  border-top: 1px solid var(--line);\n  padding-top: 14px;\n}\n.auth-confirm-q {\n  color: var(--muted);\n  font-size: 12px;\n  text-align: center;\n  margin-bottom: 12px;\n  line-height: 1.6;\n}\n.auth-confirm-q b {\n  color: var(--heading);\n}\n.welcome-title {\n  font-size: 15px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  color: var(--heading);\n}\n.welcome-sub {\n  font-size: 12px;\n  color: var(--muted);\n  line-height: 1.6;\n  margin-top: -4px;\n}\n\n/* ---- bottom tab bar ---- */\n.tabbar {\n  flex-shrink: 0;\n  display: flex;\n  background: var(--bg);\n  border-top: 1px solid var(--line);\n  padding-bottom: env(safe-area-inset-bottom);\n}\n.tab {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 10px 0 9px;\n  color: var(--muted);\n  text-decoration: none;\n  font-size: 8px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  transition: color 0.15s;\n}\n.tab-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 20px;\n  opacity: 0.75;\n  transition: opacity 0.15s, transform 0.1s;\n}\n.tab-icon svg {\n  width: 20px;\n  height: 20px;\n  display: block;\n}\n.tab-active {\n  color: var(--accent);\n}\n.tab-active .tab-icon {\n  opacity: 1;\n}\n.tab:active .tab-icon {\n  transform: scale(0.88);\n}\n\n/* ---- week strip ---- */\n.week {\n  display: flex;\n  gap: 5px;\n  margin-bottom: 12px;\n}\n.wk {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  padding: 5px 0 4px;\n  border: 1px solid var(--line-soft);\n  border-radius: var(--r);\n  background: transparent;\n  transition: background 0.15s, border-color 0.15s, transform 0.1s;\n}\n.wk:active {\n  transform: scale(0.94);\n}\n.wk:disabled {\n  opacity: 0.35;\n  pointer-events: none;\n}\n.wk-dow {\n  font-size: 9px;\n  font-weight: 700;\n  color: var(--muted);\n  letter-spacing: 1px;\n}\n.wk-dom {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text);\n}\n.wk-today .wk-dom {\n  color: var(--accent);\n}\n.wk-on {\n  background: var(--accent-dim);\n  border-color: var(--accent);\n}\n.wk-on .wk-dow,\n.wk-on .wk-dom {\n  color: var(--accent);\n}\n\n/* ---- today head ---- */\n.today-head {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n.today-title {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  min-width: 130px;\n  text-align: center;\n  color: var(--heading);\n}\n.icon-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--r);\n  font-size: 22px;\n  color: var(--muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s, transform 0.1s;\n}\n.icon-btn.sm {\n  width: 30px;\n  height: 30px;\n  font-size: 20px;\n}\n.icon-btn:active {\n  background: var(--panel-2);\n  transform: scale(0.92);\n}\n.icon-btn:disabled {\n  opacity: 0.25;\n  pointer-events: none;\n}\n.linkish {\n  color: var(--accent);\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  padding: 2px 0;\n}\n\n/* ---- daily summary ---- */\n.summary {\n  border: 1px solid var(--line);\n  background: var(--panel);\n  border-radius: var(--r);\n  padding: 16px;\n  margin-bottom: 16px;\n}\n.cal-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n}\n.cal-now {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n.cal-now-num {\n  font-size: 30px;\n  font-weight: 700;\n  letter-spacing: -1px;\n  color: var(--heading);\n}\n.cal-now-unit {\n  color: var(--muted);\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n.cal-status {\n  color: var(--muted);\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n/* dual-marker track: fill = consumed; ticks = target + maintenance */\n.cal-track {\n  position: relative;\n  height: 8px;\n  border-radius: 2px;\n  background: var(--track);\n  overflow: hidden;\n  margin-top: 12px;\n}\n.cal-fill {\n  height: 100%;\n  transition: width 0.5s cubic-bezier(0.25, 1, 0.5, 1), background 0.3s;\n}\n.cal-mark {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  transform: translateX(-1px);\n}\n.cal-mark-target {\n  background: var(--accent);\n}\n.cal-mark-maint {\n  background: var(--heading);\n  opacity: 0.55;\n}\n.cal-lines {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n.cal-line {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.cal-line-k {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--muted);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  font-size: 9px;\n  font-weight: 700;\n}\n.cal-line-v {\n  color: var(--text);\n  font-size: 12px;\n  font-weight: 700;\n}\n.cal-tick {\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n.cal-tick-target {\n  background: var(--accent);\n}\n.cal-tick-maint {\n  background: var(--heading);\n  opacity: 0.55;\n}\n\n/* ---- macro bars ---- */\n.macros {\n  display: flex;\n  flex-direction: column;\n  gap: 13px;\n  margin-top: 18px;\n  padding-top: 16px;\n  border-top: 1px solid var(--line-soft);\n}\n.macro {\n  width: 100%;\n}\n.macro-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 6px;\n}\n.macro-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n}\n.macro-val {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--text);\n}\n.macro-unit {\n  color: var(--muted);\n  font-weight: 400;\n}\n.macro-goal {\n  color: var(--muted);\n  font-size: 11px;\n  font-weight: 400;\n}\n.macro-track {\n  height: 5px;\n  border-radius: 2px;\n  background: var(--track);\n  overflow: hidden;\n}\n.macro-fill {\n  height: 100%;\n  transition: width 0.5s cubic-bezier(0.25, 1, 0.5, 1);\n}\n/* fat has no goal by default — show a faint baseline instead of an empty bar */\n.macro-track-empty {\n  height: 100%;\n  background: repeating-linear-gradient(90deg, var(--line-soft) 0 6px, transparent 6px 12px);\n  opacity: 0.6;\n}\n\n/* ---- timeline ---- */\n.timeline {\n  display: flex;\n  flex-direction: column;\n}\n.tl-row {\n  display: flex;\n  gap: 10px;\n}\n.tl-time {\n  width: 58px;\n  flex-shrink: 0;\n  text-align: right;\n  font-size: 10px;\n  color: var(--muted);\n  padding-top: 15px;\n  letter-spacing: 0.5px;\n}\n.tl-rail {\n  width: 12px;\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n.tl-rail::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: var(--line);\n}\n.tl-row:first-child .tl-rail::before {\n  top: 17px;\n}\n.tl-row:last-child .tl-rail::before {\n  bottom: calc(100% - 25px);\n}\n.tl-dot {\n  position: absolute;\n  top: 17px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--accent);\n  box-shadow: 0 0 0 3px var(--bg);\n}\n.tl-card {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  text-align: left;\n  border: 1px solid var(--line-soft);\n  background: var(--panel);\n  border-radius: var(--r);\n  padding: 10px 12px;\n  margin-bottom: 9px;\n  transition: transform 0.1s, border-color 0.15s;\n}\n.tl-card:active {\n  transform: scale(0.99);\n  border-color: var(--faint);\n}\n.tl-thumb {\n  width: 44px;\n  height: 44px;\n  border-radius: var(--r);\n  object-fit: cover;\n  flex-shrink: 0;\n}\n.tl-body {\n  flex: 1;\n  min-width: 0;\n}\n.tl-name {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--heading);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.tl-cal {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--heading);\n}\n\n.entry-macros {\n  display: flex;\n  gap: 10px;\n  margin-top: 3px;\n  font-size: 10px;\n  color: var(--muted);\n}\n.entry-qty {\n  color: var(--muted);\n}\n\n.add-hint {\n  text-align: center;\n  margin: 10px 0 4px;\n}\n\n/* ---- generic entry rows (Foods) ---- */\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.entry {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  text-align: left;\n  border: 1px solid var(--line-soft);\n  background: var(--panel);\n  border-radius: var(--r);\n  padding: 12px 13px;\n  transition: transform 0.1s, border-color 0.15s;\n}\n.entry:active {\n  transform: scale(0.99);\n  border-color: var(--faint);\n}\n.entry-static:active {\n  transform: none;\n  border-color: var(--line-soft);\n}\n.entry-main {\n  flex: 1;\n  min-width: 0;\n}\n.entry-name {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--heading);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.entry-cal {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--heading);\n}\n.entry-del {\n  color: var(--muted);\n  font-size: 12px;\n  padding: 6px;\n  margin: -6px -4px -6px 0;\n  border-radius: var(--r);\n  transition: color 0.15s, background 0.15s;\n}\n.entry-del:active {\n  color: var(--danger);\n  background: var(--panel-2);\n}\n\n.empty {\n  text-align: center;\n  color: var(--muted);\n  padding: 40px 20px;\n  line-height: 1.7;\n  font-size: 12px;\n}\n\n/* ---- floating action button ---- */\n.fab {\n  position: absolute;\n  right: 18px;\n  bottom: calc(74px + env(safe-area-inset-bottom));\n  width: 52px;\n  height: 52px;\n  border-radius: 6px;\n  background: var(--fab-bg);\n  border: 1.5px solid var(--lav);\n  color: var(--lav);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.22);\n  transition: transform 0.12s, border-color 0.15s;\n  z-index: 20;\n}\n.fab svg {\n  width: 26px;\n  height: 26px;\n}\n.fab:active {\n  transform: scale(0.9);\n}\n\n/* ---- bottom sheet ---- */\n.sheet-backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: flex-end;\n  z-index: 40;\n  animation: fade 0.2s ease;\n}\n.sheet {\n  width: 100%;\n  background: var(--bg);\n  border-top: 1px solid var(--line);\n  border-radius: var(--r) var(--r) 0 0;\n  padding: 10px 16px calc(20px + env(safe-area-inset-bottom));\n  max-height: 92%;\n  overflow-y: auto;\n  animation: slideup 0.28s cubic-bezier(0.25, 1, 0.5, 1);\n}\n@keyframes slideup {\n  from {\n    transform: translateY(100%);\n  }\n}\n@keyframes fade {\n  from {\n    opacity: 0;\n  }\n}\n.sheet-handle {\n  width: 36px;\n  height: 3px;\n  border-radius: 2px;\n  background: var(--line);\n  margin: 4px auto 14px;\n}\n.sheet-title {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  color: var(--heading);\n  margin-bottom: 12px;\n}\n.sheet-sep {\n  text-align: center;\n  color: var(--muted);\n  font-size: 9px;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  margin: 14px 0 10px;\n}\n.sheet-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 18px;\n}\n.sheet-note {\n  font-size: 11px;\n  color: var(--muted);\n  margin-top: 12px;\n  line-height: 1.6;\n}\n.sheet-photo {\n  position: relative;\n  margin: 8px 0 4px;\n  border: 1px solid var(--line-soft);\n  border-radius: var(--r);\n  overflow: hidden;\n}\n.sheet-photo img {\n  width: 100%;\n  max-height: 240px;\n  object-fit: cover;\n  display: block;\n}\n.analyzing {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: #fff;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n}\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.25);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: spin 0.7s linear infinite;\n}\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.results {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 8px;\n  max-height: 220px;\n  overflow-y: auto;\n}\n.result {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid var(--line-soft);\n  background: var(--panel);\n  border-radius: var(--r);\n  padding: 11px 13px;\n  text-align: left;\n  transition: border-color 0.15s;\n}\n.result:active {\n  border-color: var(--accent);\n}\n.result-name {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--heading);\n}\n.result-cal {\n  font-size: 11px;\n  color: var(--accent);\n}\n\n/* ---- forms ---- */\n.input {\n  width: 100%;\n  background: var(--panel-2);\n  border: 1px solid var(--line);\n  border-radius: var(--r);\n  padding: 12px 13px;\n  color: var(--text);\n  font-size: 15px;\n  outline: none;\n  transition: border-color 0.15s;\n}\n.input::placeholder {\n  color: var(--muted);\n}\n.input:focus {\n  border-color: var(--accent);\n}\n.input.mt {\n  margin-top: 12px;\n}\n.row {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n}\n.field {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.field-wide {\n  margin-top: 12px;\n}\n.field-label {\n  font-size: 9px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  color: var(--muted);\n}\n\n/* ---- buttons ---- */\n.btn {\n  flex: 1;\n  border-radius: var(--r);\n  padding: 13px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  transition: transform 0.1s, opacity 0.15s;\n}\n.btn:active {\n  transform: scale(0.98);\n}\n.btn:disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.btn-primary {\n  background: var(--accent);\n  color: var(--on-accent);\n}\n.btn-danger {\n  background: transparent;\n  color: var(--danger);\n  border: 1px solid var(--line);\n  flex: 0 0 auto;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.btn-ghost {\n  width: 100%;\n  background: transparent;\n  border: 1px solid var(--line);\n  color: var(--muted);\n}\n.btn-block {\n  width: 100%;\n  margin-top: 18px;\n}\n\n/* ---- page headers ---- */\n.page-head {\n  margin-bottom: 20px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--line);\n}\n.page-head h1 {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 3px;\n  color: var(--heading);\n}\n.page-sub {\n  color: var(--muted);\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  display: block;\n  margin-top: 6px;\n}\n\n/* ---- cards / stats ---- */\n.card {\n  border: 1px solid var(--line);\n  background: var(--panel);\n  border-radius: var(--r);\n  padding: 16px;\n}\n.stat-row {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n.stat {\n  flex: 1;\n  border: 1px solid var(--line-soft);\n  background: var(--panel);\n  border-radius: var(--r);\n  padding: 14px;\n}\n.stat-value {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--heading);\n  letter-spacing: -0.5px;\n}\n.stat-unit {\n  font-size: 11px;\n  color: var(--muted);\n}\n.stat-label {\n  color: var(--muted);\n  font-size: 9px;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  margin-top: 4px;\n}\n\n/* ---- history ---- */\n.hist {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n}\n.hist-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.hist-date {\n  width: 84px;\n  flex-shrink: 0;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--muted);\n}\n.hist-bar-track {\n  flex: 1;\n  position: relative;\n  height: 20px;\n  background: var(--track);\n  border-radius: var(--r);\n  overflow: hidden;\n}\n.hist-bar {\n  height: 100%;\n  transition: width 0.5s cubic-bezier(0.25, 1, 0.5, 1);\n}\n.hist-goal {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: var(--faint);\n}\n.hist-cal {\n  width: 50px;\n  flex-shrink: 0;\n  text-align: right;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--heading);\n}\n\n.ios-tip {\n  margin-top: 12px;\n  padding: 12px 14px;\n  border: 1px solid var(--line-soft);\n  border-radius: var(--r);\n  background: var(--panel);\n  color: var(--muted);\n  font-size: 12px;\n  line-height: 1.6;\n  text-align: center;\n}\n.ios-tip b {\n  color: var(--heading);\n}\n\n.footnote {\n  text-align: center;\n  color: var(--muted);\n  font-size: 9px;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  line-height: 1.8;\n  margin-top: 22px;\n}\n\n/* ---- toast ---- */\n.toast {\n  position: absolute;\n  left: 16px;\n  right: 16px;\n  bottom: calc(84px + env(safe-area-inset-bottom));\n  background: var(--danger);\n  color: #fff;\n  padding: 12px 15px;\n  border-radius: var(--r);\n  font-size: 12px;\n  text-align: center;\n  z-index: 50;\n  animation: slideup 0.25s ease;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
